import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=7b0fe3db&scoped=true&"
import script from "./Products.vue?vue&type=script&lang=js&"
export * from "./Products.vue?vue&type=script&lang=js&"
import style0 from "./Products.vue?vue&type=style&index=0&id=7b0fe3db&prod&lang=less&scoped=true&"
import style1 from "./Products.vue?vue&type=style&index=1&id=7b0fe3db&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0fe3db",
  null
  
)

export default component.exports